import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import KeycloakManager from "../keyCloakManager";
import { spocLogin } from "../spocLogin";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const PrivateRoute = ({ element }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch();

  // 🚫 Redirect to /no-access if noAccessRedirected is true and user tries to go elsewhere
  useEffect(() => {
    const noAccess = localStorage.getItem("noAccessRedirected");
    if (noAccess === "true" && location.pathname !== "/no-access") {
      window.location.href = "/no-access";
    }
  }, [location.pathname]);

  useEffect(() => {
    const initializeKeycloak = async () => {
      try {
        const { isLogin, loading } = await KeycloakManager.initialize();
        setIsLogin(isLogin);
        setLoading(loading);

        if (isLogin) {
          await dispatch(spocLogin());
        }
      } catch (error) {
        console.error("Keycloak initialization error", error);
        setLoading(false);
      }
    };

    initializeKeycloak();
  }, [dispatch]);

  // ⏳ Show loader while checking auth
  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center heightNodData">
        <img
          src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
          width={50}
          alt="Loading..."
        />
      </div>
    );
  }

  // ✅ User is logged in and wants to access "/"
  if (isLogin) {
    if (location.pathname === "/") {
      return <Navigate to="/Dashboard" />;
    }
    return element;
  }

  // 🔒 Not logged in: redirect to dashboard (default route)
  return <Navigate to="/Dashboard" />;
};

export default PrivateRoute;
